import { configureStore } from "@reduxjs/toolkit";
import mainDataReducer from "./slices/mainDataSlice";

export const store = configureStore({
  reducer: {
    main: mainDataReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

export default store;
